import { render, staticRenderFns } from "./CaseHistory.vue?vue&type=template&id=8ba30ade&scoped=true&"
import script from "./CaseHistory.vue?vue&type=script&lang=ts&"
export * from "./CaseHistory.vue?vue&type=script&lang=ts&"
import style0 from "./CaseHistory.vue?vue&type=style&index=0&id=8ba30ade&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba30ade",
  null
  
)

export default component.exports